module.exports = __webpack_public_path__ + "static/img/tuzhi.540906b0.png";